<template>
	<div class="app-promo-cta">
		<modal
			:size="$store.getters.layout == 'Desktop' ? 'auto' : 'max'"
			:show="showModal"
			:positionCloseX="'center'"
			:disableOutSideClick="true"
			:showCloseButton="false"
			:className="'scratch-card-modal-cta'"
			@close="showModal = false"
		>
			<template slot="modal-content">
				<div @close="showModal = false">
					<div class="app-promo-cta__container">
						<img
							src="https://cdn.betika.com/int_assets/ke/promotions/gwara-gwara/suprice-win-300x300.png"
							:alt="'App Promo'"
							class="app-promo-cta__container__artwork"
						/>

						<div class="app-promo-cta__container__content">
							<h2>Offer! Offer! Offer!</h2>
							<p>Download our app to win in our Betika Na App promotion.</p>
						</div>
						<div class="app-promo-cta__container__actions">
							<!-- TODO: CHECK IF USER IS ON MOBILE APP -> Redirect to /promotions/app-download/games ELSE if USER IS ON MOBILE WEB -> Redirect to DOWNLOAD APP env.appLink -->
							<a
								class="app-promo-cta__container__actions__btn block"
								:href="env.appLink"
								@click="showModal = false"
							>
								{{ $t("promotions.btn.participate-now") }}
							</a>
							<router-link
								class="app-promo-cta__container__actions__btn light"
								:to="'#'"
								@click.native="showModal = false"
							>
								{{ $t("promotions.btn.no-thanks") }}
							</router-link>
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>
<script>
export default {
	data() {
		return { showModal: false };
	},
	watch: {
		showModal(v) {
			if (!v) {
				const storeTodaysDate = (date = "") =>
					localStorage.setItem("showPromoModal", JSON.stringify(date));
				storeTodaysDate(new Date().toLocaleDateString());
			}
		},
	},
	mounted() {
		let vm = this;
		localStorage.getItem("showPromoModal") !== null
			? (vm.showModal =
					JSON.parse(localStorage.getItem("showPromoModal")) !==
					new Date().toLocaleDateString())
			: (vm.showModal = true);
		localStorage.setItem(
			"showPromoModal",
			JSON.stringify(new Date().toLocaleDateString())
		);
	},
};
</script>
<style lang="scss">
.app-promo-cta {
	&__container {
		&__artwork {
			width: 100%;
			max-width: 300px;
		}
		text-align: center;
		&__content {
			h2 {
				font-size: var(--font-massive);
				font-weight: var(--font-weight-normal);
				color: var(--active-state);
				margin-bottom: 0;
			}
			p {
				color: var(--non-active-state);
				font-weight: var(--font-weight-lighter);
				margin-top: 5px;
			}
		}
		&__actions {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 8px;

			&__btn {
				width: 100%;
				border-radius: 4px;
				cursor: pointer;
				padding: 10px 15px;
				text-decoration: none;
				font-size: var(--font-normal);
				font-weight: var(--font-weight-medium);
				margin-top: 15px;
				&.block {
					background: var(--green);
					color: var(--always-white);
				}
				&.light {
					background: var(--color-primary-lightest, #f5ffe9);
					color: var(--color-primary-primary, #60981a);
				}
			}
		}
	}
}
.scratch-card-modal-cta {
	.modal__container {
		padding-top: 20px;
	}
}
</style>
